import { render, staticRenderFns } from "./NextContacts.vue?vue&type=template&id=340837ec&scoped=true"
import script from "./NextContacts.vue?vue&type=script&lang=js"
export * from "./NextContacts.vue?vue&type=script&lang=js"
import style0 from "./NextContacts.vue?vue&type=style&index=0&id=340837ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340837ec",
  null
  
)

export default component.exports